import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import GasStationList from './list';
import GasStationShow from './show';
import GasStationCreate from './create';

export default {
    list: GasStationList,
    show: GasStationShow,
    create: GasStationCreate,
    icon: LocalGasStationIcon,
};
